var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"dashboard-root"},[_c('FixedBanner',{attrs:{"header":true}}),_vm._v(" "),_c('FixedBanner',{attrs:{"consent":true}}),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('FixedBanner',{attrs:{"footer":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }